<div style="padding: 10px" *ngIf="!cargandoInformacion && habilitado">
  <app-titulo-h1
    *ngIf="etiqueta_consulta"
    [titulo]="etiqueta_consulta"
  ></app-titulo-h1>

  <ng-container *ngIf="empresas.length == 0 && !esAnonimo">
    <app-alerta-error
      id="existe-error"
      mensaje_unico="{{ mensajeError }}"
    ></app-alerta-error>
  </ng-container>

  <ng-container *ngIf="empresas.length > 0">
    <!-- Nombre -->
    <app-campo-default
      id="nombre"
      descripcion_etiqueta="Nombre"
      placeholder_input="Ingresa tu nombre y apellido"
      [(ngModel)]="nombre"
      mensaje_error="{{ nombre_error_mensaje }}"
      [disabled]="true"
    ></app-campo-default>
    <app-error-seguimiento
      *ngIf="errorTrackingService.esErrorActual('nombre')"
    ></app-error-seguimiento>

    <!-- Selector de empresas si no hay ninguna seleccionada -->
    <ng-container *ngIf="empresaSeleccionada == null">
      <app-selector-empresa
        [empresas]="empresas"
        [ctx]="ctx"
        [empresasOriginales]="empresas"
        [persIdentificador]="persIdentificador"
        (seleccionEmpresa)="onEmpresaSeleccionada($event)"
        [buscador]="busquedaManualEmpresa"
        *ngIf="empresas.length > 0 || busquedaManualEmpresa"
      ></app-selector-empresa>
    </ng-container>
    <ng-container *ngIf="errorValidacion">
      <app-alerta-error
        id="existe-error-permiso"
        mensaje_unico="{{ mensajeError }}"
      ></app-alerta-error>
    </ng-container>

    <ng-container *ngIf="empresaSeleccionada != null">
      <!-- Snippet de empresa seleccionada -->
      <app-snippet-empresa
        [empresaItem]="empresaSeleccionada"
        [permiteSeleccionar]="false"
      ></app-snippet-empresa>
      <a
        class="css-a_enlace_cambiar_empresa a_enlace_cambiar_empresa"
        (click)="onEmpresaSeleccionada(null)"
      >
        <div class="css-icono_cambiar_empresa icono_cambiar_empresa">
          <img
            src="assets/images/vectors83132016.svg"
            width="13px"
            height="13px"
            class="css-Vector_vector vector_vector"
            alt="icono cambiar empresa"
          />
        </div>
        <p
          data-wcfid="texto_cambiar_empresa"
          class="css-texto_cambiar_empresa texto_cambiar_empresa"
        >
          Cambiar empresa
        </p>
      </a>

      <!-- Consulta -->
      <app-campo-texto
        id="consulta"
        placeholder_input="Escribí tu consulta."
        [(ngModel)]="consulta"
        [attachment]="true"
        etiqueta="Consulta"
        (obtener_attachments)="actualizarAdjuntos($event)"
        mensaje_error="{{ consulta_error_mensaje }}"
        [caracteres_maximo]="caracteres_maximo_consulta"
      ></app-campo-texto>
      <app-error-seguimiento
        *ngIf="errorTrackingService.esErrorActual('consulta')"
      ></app-error-seguimiento>

      <app-adjuntar-archivo
        etiqueta="Adjuntar archivos"
        (obtener_attachments)="actualizarAdjuntos($event)"
      ></app-adjuntar-archivo>

      <p *ngIf="correoUsuarioOpcion.length > 0 || correoEmpresasOpcion.length > 0">Dirección de correo en la que desea recibir la respuesta:</p>

      <app-grupo-radiobutton
        descripcion_etiqueta="Correo del usuario personal BPS"
        *ngIf="correoUsuarioOpcion.length > 0"
        [(opciones)]="correoUsuarioOpcion"
        [(ngModel)]="emailRespuesta"
        valor_defecto="parami"
      ></app-grupo-radiobutton>

      <app-grupo-radiobutton
        *ngIf="correoEmpresasOpcion.length > 0"
        descripcion_etiqueta="Correo de contacto de la empresa"
        [(opciones)]="correoEmpresasOpcion"
        [(ngModel)]="emailRespuesta"
        valor_defecto="parami"
      ></app-grupo-radiobutton>

      <div>
        <app-boton-primario-consulta
        *ngIf="correoUsuarioOpcion.length > 0 || correoEmpresasOpcion.length > 0"
          [boton_texto]="
            onSubmitProcess ? 'Enviando consulta' : 'Enviar consulta'
          "
          (boton_funcion)="realizarConsulta()"
          [disabled]="onSubmitProcess"
        ></app-boton-primario-consulta>
      </div>
    </ng-container>

    <app-alerta-error
      id="existe-error"
      *ngIf="errores.length > 0"
      [errores]="errores"
    ></app-alerta-error>
  </ng-container>
  <div class="spinner-center" style="padding-bottom: 5px; padding-top: 5px">
    <app-boton-secundario-consulta
      *ngIf="fromMenu"
      boton_texto="Volver al inicio"
      (boton_funcion)="switchAssistantHandler()"
    ></app-boton-secundario-consulta>
  </div>
</div>

<div class="spinner-overlay" *ngIf="cargandoInformacion">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label"> &nbsp;Cargando datos... </label>
  </div>
</div>
<div class="spinner-overlay" *ngIf="onSubmitProcess">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label"> &nbsp;Enviando consulta... </label>
  </div>
</div>
<div class="spinner-overlay" *ngIf="!cargandoInformacion && !habilitado">
  <div class="card-body-content" *ngIf="!habilitado && !onError">
    <h4 class="titulo-principal mt-2 mb-4 f-22">
      No es posible visualizar el contenido del presente formulario ya que se
      encuentra deshabilitado.
    </h4>
    <br />
  </div>
  <div class="card-body-content" *ngIf="onError">
    <h4 class="titulo-principal mt-2 mb-4 f-22">
      En este momento no podemos atenderlo debido a que estamos experimentando
      algunos problemas técnicos; por favor intente comunicarse con nosotros más
      tarde.
    </h4>
    <br />
  </div>
</div>
